import type { PaymentState } from '../types/paymentService.types';

export const initialState: PaymentState = {
  callerContext: { callerModule: '', redirectURL: '', backURL: '' },
  paymentDetails: [],
  totalAmount: 0,
  paymentReceipt: {
    checkStatusURL: '',
    referenceNumber: '',
  },
  payorInformation: null,
  selectedTokenizedCard: null,
};
